import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { authActions } from "../../store/auth.slice";
import { webViewLogin } from "../../services/AuthServices";
import Utils from "../../utils";
import { toast } from "react-toastify";

const MoloniEntry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector((state) => state.auth.value);

  const token = localStorage.getItem("webview_token");
  const isApp = Number(localStorage.getItem("isApp"));

  // useEffect(() => {
  //   if (Object.keys(auth).length > 0) {
  //     alert("11111")
  //     navigate("/moloni", { replace: true });
  //     return;
  //   }

  //   if (!token || isApp !== 1) {
  //     alert("222222")

  //     navigate("/", { replace: true });
  //     return;
  //   }

  //   webViewLogin({ token })
  //     .then((response) => {
  //       let userData = response?.data?.data;
  //       if (userData) {
  //         Utils.setDetail(userData);
  //         dispatch(authActions.login(userData));
  //         navigate("/moloni");
  //       }
  //     })
  //     .catch((error) => {
  //       toast.error(Utils.getErrorMessage(error));
  //       navigate("/", { replace: true });
  //     })
  //     .finally(() => {});
  // }, [auth, token, isApp, dispatch, navigate]);

  useEffect(() => {
    let interval;

    const checkToken = () => {
      const token = localStorage.getItem("webview_token");
      const isApp = Number(localStorage.getItem("isApp"));

      if (token && isApp === 1) {
        clearInterval(interval);

        webViewLogin({ token })
          .then((response) => {
            const userData = response?.data?.data;
            if (userData) {
              Utils.setDetail(userData);
              dispatch(authActions.login(userData));
              navigate("/moloni", { replace: true });
            }
          })
          .catch((error) => {
            toast.error(Utils.getErrorMessage(error));
            navigate("/", { replace: true });
          });
      }
    };

    interval = setInterval(checkToken, 300);

    return () => clearInterval(interval);
  }, []);

  return null;
};

export default MoloniEntry;
